module.exports = __webpack_public_path__ + "static/media/logoWhite.0035250b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logoWhite.svg
 ** module id = 627
 ** module chunks = 0
 **/